import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface EffectsState {
  particlesEnabled: boolean;
  clickEffectsEnabled: boolean;
  mouseAttractionEnabled: boolean;
  waveEffectsEnabled: boolean;
  forcedDisabled: boolean;
  initializedFromSiteConfig: boolean;
  
  toggleParticles: () => void;
  toggleClickEffects: () => void;
  toggleMouseAttraction: () => void;
  toggleWaveEffects: () => void;
  setParticlesEnabled: (enabled: boolean) => void;
  setClickEffectsEnabled: (enabled: boolean) => void;
  setMouseAttractionEnabled: (enabled: boolean) => void;
  setWaveEffectsEnabled: (enabled: boolean) => void;
  applySiteEffectsConfig: (config: {
    enabled?: boolean;
    particlesEnabled?: boolean;
    clickEffectsEnabled?: boolean;
    mouseAttractionEnabled?: boolean;
    waveEffectsEnabled?: boolean;
  } | null | undefined) => void;
}

export const useEffectsStore = create<EffectsState>()(
  persist(
    (set, get) => ({
      particlesEnabled: true,
      clickEffectsEnabled: true,
      mouseAttractionEnabled: true,
      waveEffectsEnabled: true,
      forcedDisabled: false,
      initializedFromSiteConfig: false,
      
      toggleParticles: () => {
        if (get().forcedDisabled) return;
        set({ particlesEnabled: !get().particlesEnabled });
      },
      
      toggleClickEffects: () => {
        if (get().forcedDisabled) return;
        set({ clickEffectsEnabled: !get().clickEffectsEnabled });
      },
      
      toggleMouseAttraction: () => {
        if (get().forcedDisabled) return;
        set({ mouseAttractionEnabled: !get().mouseAttractionEnabled });
      },
      
      toggleWaveEffects: () => {
        if (get().forcedDisabled) return;
        set({ waveEffectsEnabled: !get().waveEffectsEnabled });
      },
      
      setParticlesEnabled: (enabled: boolean) => {
        if (get().forcedDisabled) return;
        set({ particlesEnabled: enabled });
      },
      
      setClickEffectsEnabled: (enabled: boolean) => {
        if (get().forcedDisabled) return;
        set({ clickEffectsEnabled: enabled });
      },
      
      setMouseAttractionEnabled: (enabled: boolean) => {
        if (get().forcedDisabled) return;
        set({ mouseAttractionEnabled: enabled });
      },
      
      setWaveEffectsEnabled: (enabled: boolean) => {
        if (get().forcedDisabled) return;
        set({ waveEffectsEnabled: enabled });
      },

      applySiteEffectsConfig: (config) => {
        if (!config) return;

        const enabled = config.enabled !== false;
        if (!enabled) {
          set({
            forcedDisabled: true,
            particlesEnabled: false,
            clickEffectsEnabled: false,
            mouseAttractionEnabled: false,
            waveEffectsEnabled: false,
            initializedFromSiteConfig: true,
          });
          return;
        }

        set({ forcedDisabled: false });

        if (get().initializedFromSiteConfig) {
          return;
        }

        set({
          initializedFromSiteConfig: true,
          particlesEnabled: config.particlesEnabled !== false,
          clickEffectsEnabled: config.clickEffectsEnabled !== false,
          mouseAttractionEnabled: config.mouseAttractionEnabled !== false,
          waveEffectsEnabled: config.waveEffectsEnabled !== false,
        });
      },
    }),
    {
      name: 'effects-settings',
      version: 2,
    }
  )
);
